import { render, staticRenderFns } from "./UserDebts.vue?vue&type=template&id=0f3c310b&"
import script from "./UserDebts.vue?vue&type=script&lang=js&"
export * from "./UserDebts.vue?vue&type=script&lang=js&"
import style0 from "./UserDebts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports